module.exports = __webpack_public_path__ + "f892f381786dd26f0b08da91a603b671.png";